import { groups, logConfiguration } from '../../mocks/Settings';
import { SettingGroup, LogLevelConfiguration } from 'vrlcm-gui-types';

export default class SettingsMockAPI {
  public static getSettingGroups = (): Promise<SettingGroup[]> => {
    return Promise.resolve(groups);
  };

  public static getLogConfiguration = (): Promise<LogLevelConfiguration> => {
    return Promise.resolve(logConfiguration);
  };
}
